import { VehicleModel } from "./types";

export const mockVehicleModels: VehicleModel[] = [
  {
    id: "1",
    modelName: "Ridebase test",
    bodyType: "Minivan",
    rangeOnFull: "1000 km",
    class: "B",
    packageCapacity: 6,
    passengerSeats: 6,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 34
  },
  {
    id: "2",
    modelName: "Honda Civic",
    bodyType: "Hatchback",
    rangeOnFull: "500 km",
    class: "A",
    packageCapacity: 2,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 12
  },
  {
    id: "3",
    modelName: "Toyota Previa",
    bodyType: "Minivan",
    rangeOnFull: "500 km",
    class: "B",
    packageCapacity: 20,
    passengerSeats: 6,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 3
  },
  {
    id: "4",
    modelName: "Hyundai Kona EV",
    bodyType: "SUV",
    rangeOnFull: "450 km",
    class: "A",
    packageCapacity: 2,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "EV",
    vehiclesInFleet: 9
  },
  {
    id: "5",
    modelName: "Honda Civic",
    bodyType: "Sedan",
    rangeOnFull: "450 km",
    class: "A",
    packageCapacity: 3,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 615
  },
  {
    id: "6",
    modelName: "Dodge Grand Caravan",
    bodyType: "Minivan",
    rangeOnFull: "500 km",
    class: "B",
    packageCapacity: 4,
    passengerSeats: 6,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 28
  },
  {
    id: "7",
    modelName: "Acura ILX",
    bodyType: "Sedan",
    rangeOnFull: "1000 km",
    class: "A",
    packageCapacity: 4,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 8
  },
  {
    id: "8",
    modelName: "Acura RDX",
    bodyType: "SUV",
    rangeOnFull: "1000 km",
    class: "A",
    packageCapacity: 4,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 10
  },
  {
    id: "9",
    modelName: "Acura TLX",
    bodyType: "Sedan",
    rangeOnFull: "1000 km",
    class: "A",
    packageCapacity: 4,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 3
  },
  {
    id: "10",
    modelName: "Audi A4",
    bodyType: "Sedan",
    rangeOnFull: "1000 km",
    class: "A",
    packageCapacity: 4,
    passengerSeats: 4,
    autonomous: false,
    powertrain: "ICE",
    vehiclesInFleet: 6
  }
];